export enum AssessmentDashboardEnum {
    Assessment = 1,
    AssessmentAI = 2,
    BHDiagnostic = 3,
    BHDiagnosticAI = 4,
    AssessmentAI2 = 5,
}
